import { render } from "./Folder.vue?vue&type=template&id=b9d98a14&scoped=true"
import script from "./Folder.vue?vue&type=script&lang=js"
export * from "./Folder.vue?vue&type=script&lang=js"

import "./Folder.vue?vue&type=style&index=0&id=b9d98a14&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d98a14"]])

export default __exports__